// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// Model
import { PhotoReviewModel } from '../model/photo-review.model';
import { DOCUMENT_ATTACHMENT_CATEGORIES } from '../../model/quality.constant';
// Service
import { SystemApiService } from '@cv-invision/core';
// Other
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PhotoReviewService {
	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {}

	/**
	 * GET - Current attachment file related with the order
	 * @param orderId: number
	 * @param category: string
	 */
	getOrderPhotos(orderId: any): Observable<Array<PhotoReviewModel>> {
		return this.httpClient
			.get(
				this.systemApiService.api.intelligenceService +
					`orders/${orderId}/documents/current/attachments?category=${
						DOCUMENT_ATTACHMENT_CATEGORIES.PhotoRequest
					}`
			)
			.pipe(
				map((payload: any) => {
					return payload;
				})
			);
	}

	/**
	 * GET - get information of the order no meta include
	 * @param orderId
	 */
	getOrderDocumentData(orderId: any): Observable<any> {
		return this.httpClient
			.get(
				`${this.systemApiService.api.intelligenceService}orders/${orderId}/documents/current/data`
			)
			.pipe(
				map(payload => {
					return payload;
				})
			);
	}
}
